import styled from 'styled-components';
import { Animated } from 'react-animated-css';
import { Modal, Radio } from 'antd';

export const Container = styled.div`
  height: 100%;

  & form > * {
    transition: all 2s ease 0.2s;
    -webkit-transition: all 2s ease 0.2s;
    /*note: not transitioning width */
    transition-property: left, right, top, bottom, visibility;
  }

  & .ant-form-item {
    display: ${(props) => (props.visibleLabel ? 'flex' : 'block')};
  }
`;

export const A = styled(Animated)`
  height: 100%;
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  justify-content: center;
`;

export const CustomModal = styled(Modal)`
  .ant-modal-content {
    height: 100%;

    .ant-modal-body {
      height: calc(100% - 53px);
    }
  }
`;
export const AddressSearchWrapper = styled.div`
  .title {
    padding: 14px 0px;
    font-size: 14px;
    font-weight: 700;
    color: #212529;
  }
  .description {
    font-size: 12px;
    font-weight: 400;
    color: #797c80;

    .sub-title {
      padding: 10px 0px 16px;
    }

    .example {
      color: #1db53a;
    }
  }
  .ant-input-affix-wrapper,
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:hover,
  input.ant-input {
    height: 48px;
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    box-shadow: none;

    input {
      height: 100%;
      border: none !important;
    }
    .ant-input-show-count-suffix {
      font-size: 12px;
      font-weight: 400;
      color: #afb3b8;
    }
  }

  .ant-input-search {
    .ant-input-wrapper {
      .ant-input-affix-wrapper,
      .ant-input-affix-wrapper:hover {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
      }
      .ant-input-group-addon .ant-btn.ant-input-search-button {
        width: 40px;
        height: 48px;
        border: 1px solid rgba(0, 0, 0, 0.4);
        border-left: none;
        border-radius: 0px 8px 8px 0px;
      }
    }
  }
`;
export const RadioGroupWrapper = styled(Radio.Group)`
  height: 290px;
  overflow-y: scroll;
  padding-right: 10px;

  &.ant-radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .ant-radio-button-wrapper,
    .ant-radio-button-wrapper:hover {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      min-height: 40px;
      padding: 0px;
      border: none;
      font-size: 12px;
      font-weight: 400;
      color: #212529;

      & span {
        width: 100%;
      }
      &:before {
        display: none;
      }
    }
  }
`;
